module.exports = __webpack_public_path__ + "HelveticaLight.f468445c731f03196547.svg";


//////////////////
// WEBPACK FOOTER
// /var/www/minha-dinamica-cliente/src/app/@theme/fontes/Helvetica/HelveticaLight.svg
// module id = ../../../../../src/app/@theme/fontes/Helvetica/HelveticaLight.svg
// module chunks = styles